"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataGrid = exports.sortRows = exports.mergeRows = exports.DisplayMode = void 0;
var react_1 = __importStar(require("react"));
var Checkbox_1 = require("../controls/Checkbox");
var DataGrid_scss_1 = __importDefault(require("./DataGrid.scss"));
var DisplayMode;
(function (DisplayMode) {
    DisplayMode[DisplayMode["Dynamic"] = 0] = "Dynamic";
    DisplayMode[DisplayMode["Fixed"] = 1] = "Fixed";
})(DisplayMode || (exports.DisplayMode = DisplayMode = {}));
function mergeRows(rows, existing, updated) {
    var newRows = rows.slice();
    var index = existing != null ? newRows.indexOf(existing) : -1;
    if (index >= 0) {
        if (updated) {
            newRows.splice(index, 1, updated);
        }
        else {
            newRows.splice(index, 1);
        }
    }
    else if (updated) {
        newRows.push(updated);
    }
    return newRows;
}
exports.mergeRows = mergeRows;
function sortRows(rows, columns, columnIndex, descending) {
    if (columnIndex < 0 || columnIndex >= columns.length) {
        return rows;
    }
    var column = columns[columnIndex];
    var newRows = rows.slice();
    newRows.sort(function (a, b) {
        var aVal = column.value(a);
        var bVal = column.value(b);
        if (aVal > bVal) {
            return 1 * (descending ? 1 : -1);
        }
        else if (aVal < bVal) {
            return -1 * (descending ? 1 : -1);
        }
        else {
            return 0;
        }
    });
    return newRows;
}
exports.sortRows = sortRows;
var DataGrid = function (props) {
    var colSpan = (0, react_1.useMemo)(function () {
        return props.columns.length + (props.expand ? 1 : 0) + (props.select ? 1 : 0);
    }, [props.columns, props.expand ? true : false]);
    var toggleExpanded = function (row) {
        var res;
        var options = props.expand;
        if (!options) {
            return;
        }
        var rows = options.rows;
        if (rows.indexOf(row) >= 0) {
            res = rows.filter(function (r) { return r != row; });
        }
        else {
            res = [row];
        }
        options.onChange && options.onChange(res);
    };
    var renderDetails = function (r) {
        var options = props.expand;
        if (!options) {
            return;
        }
        return (react_1.default.createElement("tr", { className: DataGrid_scss_1.default['au-table__row'] },
            react_1.default.createElement("td", { colSpan: colSpan, className: ['acma-details-cell', 'au-table__cell']
                    .map(function (r) { return DataGrid_scss_1.default[r]; })
                    .concat('px-0')
                    .join(' ') },
                react_1.default.createElement("div", { className: "container-fluid" }, options.content && options.content(r)))));
    };
    var renderSorting = function (column, columnIndex) {
        var _a = column.sortable, sortable = _a === void 0 ? true : _a;
        if (!props.sort || !sortable) {
            return react_1.default.createElement(react_1.default.Fragment, null);
        }
        if (props.sort.columnIndex == columnIndex) {
            return react_1.default.createElement(react_1.default.Fragment, null,
                "\u00A0",
                props.sort.descending ? react_1.default.createElement("span", null, '\u2191') : react_1.default.createElement("span", null, '\u2193'));
        }
        else {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                "\u00A0",
                react_1.default.createElement("span", null, '\u2191'),
                react_1.default.createElement("span", null, '\u2193')));
        }
    };
    var onSort = function (column, columnIndex) {
        var _a = column.sortable, sortable = _a === void 0 ? true : _a;
        if (!props.sort || !sortable) {
            return;
        }
        if (props.sort.columnIndex == columnIndex) {
            if (props.sort.descending) {
                props.sort.onChange(columnIndex, !props.sort.descending);
            }
            else {
                props.sort.onChange(-1, !props.sort.descending);
            }
        }
        else {
            props.sort.onChange(columnIndex, true);
        }
    };
    var allSelected = (0, react_1.useMemo)(function () {
        if (props.rows.length == 0) {
            return false;
        }
        return props.select ? props.select.rows.filter(function (r) { return props.rows.indexOf(r) >= 0; }).length == props.rows.length : false;
    }, [props.select, props.select ? props.select.rows : null, props.rows]);
    var columns = props.columns, rows = props.rows;
    return (react_1.default.createElement("div", { className: DataGrid_scss_1.default['au-table__wrapper'] },
        react_1.default.createElement("table", { className: DataGrid_scss_1.default['au-table'] },
            react_1.default.createElement("thead", { className: DataGrid_scss_1.default['au-table__head'] },
                props.expand && props.expand.rows.indexOf(null) >= 0 && renderDetails(null),
                react_1.default.createElement("tr", { className: DataGrid_scss_1.default['au-table__row'] },
                    props.select && (react_1.default.createElement("th", { className: DataGrid_scss_1.default['au-table__header'], style: { width: '0px' } },
                        react_1.default.createElement(Checkbox_1.Checkbox, { id: "all", label: react_1.default.createElement(react_1.default.Fragment, null, "\u00A0"), checked: allSelected, onChange: function (v) { return props.select && props.select.onChange(v ? props.rows.slice() : []); } }))),
                    columns.map(function (c, i) {
                        var temp = ['au-table__header'];
                        if (c.rightAlign) {
                            temp.push('au-table__header--numeric');
                        }
                        if (c.width) {
                            temp.push("au-table__header--width-".concat(c.width));
                        }
                        return (react_1.default.createElement("th", { key: i, scope: "col", className: temp.map(function (c) { return DataGrid_scss_1.default[c]; }).join(' '), style: props.sort && (c.sortable || c.sortable == undefined) ? { cursor: 'pointer' } : {}, onClick: function () { return onSort(c, i); } },
                            c.label,
                            renderSorting(c, i)));
                    }),
                    props.expand ? react_1.default.createElement("th", { className: DataGrid_scss_1.default['au-table__header'], style: { width: '0px' } }) : react_1.default.createElement(react_1.default.Fragment, null))),
            react_1.default.createElement("tbody", { className: DataGrid_scss_1.default['au-table__body'] },
                rows.map(function (r, i) {
                    var expanded = props.expand && props.expand.rows.indexOf(r) >= 0;
                    var canExpand = props.expand ? (props.expand.canExpand ? props.expand.canExpand(r) : true) : false;
                    return (react_1.default.createElement(react_1.default.Fragment, { key: i },
                        react_1.default.createElement("tr", { className: DataGrid_scss_1.default['au-table__row'] },
                            props.select && (react_1.default.createElement("td", { className: DataGrid_scss_1.default['au-table__cell'], style: { width: '0px' } },
                                react_1.default.createElement(Checkbox_1.Checkbox, { id: "".concat(i), label: react_1.default.createElement(react_1.default.Fragment, null, "\u00A0"), checked: props.select.rows.indexOf(r) >= 0, onChange: function (v) {
                                        if (!props.select) {
                                            return;
                                        }
                                        var newRows = props.select.rows.filter(function (s) { return s != r; });
                                        if (v) {
                                            newRows.push(r);
                                        }
                                        props.select.onChange(newRows);
                                    } }))),
                            columns.map(function (c, j) {
                                var temp = ['au-table__cell'];
                                if (c.rightAlign) {
                                    temp.push('au-table__cell--numeric');
                                }
                                if (c.highlight && (typeof c.highlight == 'boolean' || c.highlight(r))) {
                                    temp.push('acma-higlight-cell');
                                }
                                if (props.displayMode == DisplayMode.Fixed) {
                                    temp.push("au-table__cell--nowrap");
                                }
                                return (react_1.default.createElement("td", { key: j, className: temp.map(function (c) { return DataGrid_scss_1.default[c]; }).join(' ') }, c.value(r)));
                            }),
                            canExpand ? (react_1.default.createElement("td", { className: ['acma-expand-cell', 'au-table__cell'].map(function (r) { return DataGrid_scss_1.default[r]; }).join(' '), style: { width: '0px' } },
                                react_1.default.createElement("a", { href: "#", className: DataGrid_scss_1.default['acma-expand-cell__link'], onKeyDown: function (e) {
                                        if (e.key === 'Enter') {
                                            e.preventDefault();
                                            toggleExpanded(r);
                                        }
                                    }, onClick: function (e) {
                                        e.preventDefault();
                                        toggleExpanded(r);
                                    } },
                                    expanded ? '\u02C4' : '\u02C5',
                                    expanded ? react_1.default.createElement("span", { className: "sr-only" }, "Collapse") : react_1.default.createElement("span", { className: "sr-only" }, "Expand")))) : (react_1.default.createElement("td", null))),
                        expanded && renderDetails(r)));
                }),
                rows.length > 0 && columns.findIndex(function (i) { return i.footer; }) !== -1 && !Array.isArray(columns[0].footer) && (react_1.default.createElement("tr", { className: DataGrid_scss_1.default['au-table__row'] }, columns.map(function (c, j) {
                    var temp = ['au-table__cell'];
                    if (c.rightAlign) {
                        temp.push('au-table__cell--numeric');
                    }
                    if (props.displayMode == DisplayMode.Fixed) {
                        temp.push("au-table__cell--nowrap");
                    }
                    return (react_1.default.createElement("td", { key: j, className: temp.map(function (c) { return DataGrid_scss_1.default[c]; }).join(' ') },
                        react_1.default.createElement("b", null, c.footer)));
                }))),
                rows.length > 0 && columns.findIndex(function (i) { return i.footer; }) !== -1 && Array.isArray(columns[0].footer) && (react_1.default.createElement(react_1.default.Fragment, null, columns[0].footer.map(function (r, i) {
                    return (react_1.default.createElement("tr", { key: r.toString(), className: DataGrid_scss_1.default['au-table__row'] }, columns.map(function (c, j) {
                        var footers = c.footer;
                        var temp = ['au-table__cell'];
                        if (c.rightAlign) {
                            temp.push('au-table__cell--numeric');
                        }
                        if (props.displayMode == DisplayMode.Fixed) {
                            temp.push("au-table__cell--nowrap");
                        }
                        if (c.footer && c.footer !== '') {
                            return (react_1.default.createElement("td", { key: j, className: temp.map(function (c) { return DataGrid_scss_1.default[c]; }).join(' ') },
                                react_1.default.createElement("b", null, footers[i])));
                        }
                        else {
                            return (react_1.default.createElement(react_1.default.Fragment, { key: j },
                                react_1.default.createElement("td", { colSpan: props.expand ? 2 : 1 })));
                        }
                    })));
                }))),
                rows.length == 0 && props.noRowsMessage ? (react_1.default.createElement("tr", { className: DataGrid_scss_1.default['au-table__row'] },
                    react_1.default.createElement("td", { colSpan: colSpan, className: ['au-table__cell']
                            .map(function (r) { return DataGrid_scss_1.default[r]; })
                            .concat('px-0')
                            .join(' ') },
                        react_1.default.createElement("div", { className: "container-fluid" }, props.noRowsMessage)))) : (react_1.default.createElement(react_1.default.Fragment, null))))));
};
exports.DataGrid = DataGrid;
//# sourceMappingURL=DataGrid.js.map